import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoteSuccessIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Hubs",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M-13260 -4781H5585V-4801H-13260V-4781ZM5577 -4789V7783H5597V-4789H5577ZM5585 7775H-13260V7795H5585V7775ZM-13252 7783V-4789H-13272V7783H-13252ZM-13260 7775C-13255.6 7775 -13252 7778.58 -13252 7783H-13272C-13272 7789.63 -13266.6 7795 -13260 7795V7775ZM5577 7783C5577 7778.58 5580.58 7775 5585 7775V7795C5591.63 7795 5597 7789.63 5597 7783H5577ZM5585 -4781C5580.58 -4781 5577 -4784.58 5577 -4789H5597C5597 -4795.63 5591.63 -4801 5585 -4801V-4781ZM-13260 -4801C-13266.6 -4801 -13272 -4795.63 -13272 -4789H-13252C-13252 -4784.58 -13255.6 -4781 -13260 -4781V-4801Z",
				fill: "black",
				fillOpacity: .1
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Modal - Edit note success",
				children: [/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip0_5108_8805)",
					children: [/* @__PURE__ */ _jsx("rect", {
						x: -120,
						y: -80,
						width: 440,
						height: 428,
						rx: 12,
						fill: "white"
					}), /* @__PURE__ */ _jsx("g", {
						id: "Content",
						children: /* @__PURE__ */ _jsx("g", {
							id: "create profile",
							children: /* @__PURE__ */ _jsx("g", {
								id: "create profile_2",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Add Hub owner details",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Verify",
										children: /* @__PURE__ */ _jsx("g", {
											id: "M-Empty State",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Content_2",
												children: /* @__PURE__ */ _jsxs("g", {
													id: "Note added success",
													children: [/* @__PURE__ */ _jsx("g", {
														id: "Group 300",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle 3464110",
															width: 200,
															height: 140,
															fill: "white"
														})
													}), /* @__PURE__ */ _jsxs("g", {
														id: "Group 631669",
														children: [
															/* @__PURE__ */ _jsx("path", {
																id: "Vector 1125",
																d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
																fill: "#F0FAF8"
															}),
															/* @__PURE__ */ _jsx("circle", {
																id: "Ellipse 592",
																cx: 89.6406,
																cy: 120.66,
																r: 6,
																fill: "#F0FAF8"
															}),
															/* @__PURE__ */ _jsx("circle", {
																id: "Ellipse 593",
																cx: 40.6406,
																cy: 35.6602,
																r: 8,
																fill: "#F0FAF8"
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Vector",
																d: "M64 46V106C64 112.619 69.3813 118 76 118H124C130.619 118 136 112.619 136 106V46C136 39.3813 130.619 34 124 34H114.7C114.737 34.15 114.756 34.3 114.775 34.4313C118.394 35.6125 121 39.0063 121 43V47.5C121 49.9937 118.994 52 116.5 52H100H83.5C81.0063 52 79 49.9937 79 47.5V43C79 39.0063 81.6062 35.6125 85.225 34.4313C85.2437 34.2813 85.2812 34.1312 85.3 34H76C69.3813 34 64 39.3813 64 46ZM86.5 73C86.5 74.1935 86.0259 75.3381 85.182 76.182C84.3381 77.0259 83.1935 77.5 82 77.5C80.8065 77.5 79.6619 77.0259 78.818 76.182C77.9741 75.3381 77.5 74.1935 77.5 73C77.5 71.8065 77.9741 70.6619 78.818 69.818C79.6619 68.9741 80.8065 68.5 82 68.5C83.1935 68.5 84.3381 68.9741 85.182 69.818C86.0259 70.6619 86.5 71.8065 86.5 73ZM86.5 91C86.5 92.1935 86.0259 93.3381 85.182 94.182C84.3381 95.0259 83.1935 95.5 82 95.5C80.8065 95.5 79.6619 95.0259 78.818 94.182C77.9741 93.3381 77.5 92.1935 77.5 91C77.5 89.8065 77.9741 88.6619 78.818 87.818C79.6619 86.9741 80.8065 86.5 82 86.5C83.1935 86.5 84.3381 86.9741 85.182 87.818C86.0259 88.6619 86.5 89.8065 86.5 91ZM94 73C94 71.35 95.35 70 97 70H121C122.65 70 124 71.35 124 73C124 74.65 122.65 76 121 76H97C95.35 76 94 74.65 94 73ZM94 91C94 89.35 95.35 88 97 88H121C122.65 88 124 89.35 124 91C124 92.65 122.65 94 121 94H97C95.35 94 94 92.65 94 91Z",
																fill: "url(#paint0_linear_5108_8805)"
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Vector_2",
																d: "M85.225 34.4312C86.425 27.3813 92.5937 22 100 22C107.406 22 113.575 27.3813 114.775 34.4312C118.394 35.6125 121 39.0062 121 43V47.5C121 49.9937 118.994 52 116.5 52H100H83.5C81.0062 52 79 49.9937 79 47.5V43C79 39.0062 81.6062 35.6125 85.225 34.4312ZM104.5 37C104.5 35.8065 104.026 34.6619 103.182 33.818C102.338 32.9741 101.193 32.5 100 32.5C98.8065 32.5 97.6619 32.9741 96.818 33.818C95.9741 34.6619 95.5 35.8065 95.5 37C95.5 38.1935 95.9741 39.3381 96.818 40.182C97.6619 41.0259 98.8065 41.5 100 41.5C101.193 41.5 102.338 41.0259 103.182 40.182C104.026 39.3381 104.5 38.1935 104.5 37ZM77.5 73C77.5 71.8065 77.9741 70.6619 78.818 69.818C79.6619 68.9741 80.8065 68.5 82 68.5C83.1935 68.5 84.3381 68.9741 85.182 69.818C86.0259 70.6619 86.5 71.8065 86.5 73C86.5 74.1935 86.0259 75.3381 85.182 76.182C84.3381 77.0259 83.1935 77.5 82 77.5C80.8065 77.5 79.6619 77.0259 78.818 76.182C77.9741 75.3381 77.5 74.1935 77.5 73ZM77.5 91C77.5 89.8065 77.9741 88.6619 78.818 87.818C79.6619 86.9741 80.8065 86.5 82 86.5C83.1935 86.5 84.3381 86.9741 85.182 87.818C86.0259 88.6619 86.5 89.8065 86.5 91C86.5 92.1935 86.0259 93.3381 85.182 94.182C84.3381 95.0259 83.1935 95.5 82 95.5C80.8065 95.5 79.6619 95.0259 78.818 94.182C77.9741 93.3381 77.5 92.1935 77.5 91Z",
																fill: "url(#paint1_linear_5108_8805)"
															}),
															/* @__PURE__ */ _jsxs("g", {
																id: "Fill/tick",
																children: [/* @__PURE__ */ _jsx("path", {
																	id: "Vector_3",
																	d: "M149.333 57C149.333 64.3638 143.364 70.3333 136 70.3333C128.636 70.3333 122.667 64.3638 122.667 57C122.667 49.6362 128.636 43.6666 136 43.6666C143.364 43.6666 149.333 49.6362 149.333 57Z",
																	fill: "#42AF60",
																	stroke: "white",
																	strokeWidth: 1.5,
																	strokeLinecap: "round"
																}), /* @__PURE__ */ _jsx("g", {
																	id: "Fill/tick_2",
																	children: /* @__PURE__ */ _jsx("path", {
																		id: "Vector (Stroke)",
																		fillRule: "evenodd",
																		clipRule: "evenodd",
																		d: "M141.69 51.9425C142.09 52.3234 142.105 52.9564 141.724 53.3563L134.105 61.3563C133.917 61.5545 133.655 61.6666 133.381 61.6666C133.107 61.6666 132.846 61.5545 132.657 61.3563L129.609 58.1563C129.228 57.7564 129.244 57.1234 129.644 56.7425C130.044 56.3616 130.677 56.377 131.058 56.777L133.381 59.2166L140.276 51.977C140.657 51.577 141.29 51.5616 141.69 51.9425Z",
																		fill: "white"
																	})
																})]
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Line 3",
																d: "M97 73H121",
																stroke: "url(#paint2_linear_5108_8805)",
																strokeWidth: 6,
																strokeLinecap: "round"
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Line 4",
																d: "M97 91H121",
																stroke: "url(#paint3_linear_5108_8805)",
																strokeWidth: 6,
																strokeLinecap: "round"
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Ellipse 600",
																d: "M105 37C105 39.7614 102.761 42 100 42C97.2386 42 95 39.7614 95 37C95 34.2386 97.2386 32 100 32C102.761 32 105 34.2386 105 37Z",
																fill: "url(#paint4_linear_5108_8805)"
															})
														]
													})]
												})
											})
										})
									})
								})
							})
						})
					})]
				}), /* @__PURE__ */ _jsx("rect", {
					x: -119.5,
					y: -79.5,
					width: 439,
					height: 427,
					rx: 11.5,
					stroke: "#D4D4D4"
				})]
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5108_8805",
				x1: 100,
				y1: 34,
				x2: 100,
				y2: 118,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5108_8805",
				x1: 99.25,
				y1: 22,
				x2: 99.25,
				y2: 95.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5108_8805",
				x1: 97,
				y1: 73.5,
				x2: 121,
				y2: 73.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_5108_8805",
				x1: 97,
				y1: 91.5,
				x2: 121,
				y2: 91.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5108_8805",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_5108_8805",
				children: /* @__PURE__ */ _jsx("rect", {
					x: -120,
					y: -80,
					width: 440,
					height: 428,
					rx: 12,
					fill: "white"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNoteSuccessIcon);
export { ForwardRef as ReactComponent };
